import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Shift } from "../models/Shift";

const moment = getMomentTz();

export const getShifts = async (
	params: { productionDate: Date | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{
			name: "ProductionDate",
			value: params.productionDate,
		},
	];

	const resp = await apiService.callV2(
		`[MES].[GetShiftByParameters]`,
		parameters,
		signal,
	);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []) as Shift[];
		rows = rows.map((row) => {
			(row.CurrentProductionDate = moment
				.utc(row["CurrentProductionDate"])
				.toDate()),
				(row.CurrentStart = moment.utc(row["CurrentStart"]).toDate()),
				(row.CurrentEnd = moment.utc(row["CurrentEnd"]).toDate()),
				(row.PreviousProductionDate = moment
					.utc(row["PreviousProductionDate"])
					.toDate()),
				(row.PreviousStart = moment.utc(row["PreviousStart"]).toDate()),
				(row.PreviousEnd = moment.utc(row["PreviousEnd"]).toDate()),
				(row.NextProductionDate = moment
					.utc(row["NextProductionDate"])
					.toDate()),
				(row.NextStart = moment.utc(row["NextStart"]).toDate()),
				(row.NextEnd = moment.utc(row["NextEnd"]).toDate()),
				(row.LastProductionDate = moment
					.utc(row["LastProductionDate"])
					.toDate()),
				(row.LastStart = moment.utc(row["LastStart"]).toDate()),
				(row.LastEnd = moment.utc(row["LastEnd"]).toDate());
			return row;
		});

		return rows;
	} else {
		throw new Error(resp.message || "Error fetching shifts");
	}
};
